export type Options = {
  serialize: {
    (
      value: any,
      replacer?: (this: any, key: string, value: any) => any,
      space?: string | number,
    ): string
    (
      value: any,
      replacer?: (string | number)[],
      space?: string | number,
    ): string
  }
  deserialize: (
    text: string,
    reviver?: (this: any, key: string, value: any) => any,
  ) => any
  reviver: (key: string, value: any) => any
}

export const defaultOptions = {
  serialize: JSON.stringify,
  deserialize: JSON.parse,
  reviver: function (key: string, value: any) {
    if (typeof value === "string") {
      const a =
        /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(
          value,
        );
      if (a)
        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));
    }
    return value;
  },
};

export function removeFromLocalStorage(keys: string | string[]) {
  if (Array.isArray(keys)) {
    keys.forEach(key => localStorage.removeItem(key));
  } else {
    localStorage.removeItem(keys);
  }
}

function getItemFromLocalStorage<T>(
  key: string,
  defaultValue: T | null,
  options: Options = defaultOptions,
) {
  let { deserialize } = options;
  deserialize = deserialize || defaultOptions.deserialize;

  const valueInLocalStorage = window.localStorage.getItem(key);
  if (valueInLocalStorage) {
    return deserialize!(valueInLocalStorage, options.reviver);
  }

  return typeof defaultValue === "function" ? defaultValue() : defaultValue;
}

function setItemInLocalStorage<T>(key: string, defaultValue: T | null) {
  const { serialize } = defaultOptions;

  window.localStorage.setItem(key, serialize(defaultValue));
}

export { getItemFromLocalStorage, setItemInLocalStorage };
